export var Risk;
(function (Risk) {
    Risk["Cardiological"] = "cardiological";
    Risk["Dehydration"] = "dehydration";
    Risk["Exhaustion"] = "exhaustion";
    Risk["Illness"] = "illness";
    Risk["Infection"] = "infection";
    Risk["LackOfSleep"] = "lackOfSleep";
    Risk["Obesity"] = "obesity";
    Risk["Stress"] = "stress";
})(Risk || (Risk = {}));
const FOR_HUMANS = {
    [Risk.Cardiological]: "kardiológiai állapot romlása",
    [Risk.Dehydration]: "folyadékhiány",
    [Risk.Exhaustion]: "kimerültség",
    [Risk.Illness]: "betegség",
    [Risk.Infection]: "fertőzés",
    [Risk.LackOfSleep]: "alváshiány",
    [Risk.Obesity]: "elhízás",
    [Risk.Stress]: "stressz",
};
export const riskForHumans = (risk) => FOR_HUMANS[risk];
